import React from 'react';
import './styles.scss';


class HiresCardThree extends React.Component {
  render() {

    const { text } = this.props

    return (
      <div className="hires__card3__container">
        <div className="plus__button"></div>
        <div className="hires__card__content">
          <h5 className="hires__card__text">{text}</h5>
          <button className="hires__card__button">lo quiero</button>
        </div>
      </div>
    )
  }
}


export default HiresCardThree;
